module.exports = __webpack_public_path__ + "static/media/bgBlueIllusion.38a24c4b.png";